// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"9c3c160c","394":"77485129"}[chunkId] + ".chunk.js";
};